export const langRigsStats = {
  fr: {
    stats: `Stats utilisation matériel`,
    boards: `Boards`,
    sails: `Sails/Wings`,
    active: `Active`,
    board: `Board`,
    sail: `Sail/Wing`,
    usedNb: `Nbre sessions`,
    totalTime: `Durée totale utilisation`,
    firstUse: `Première utilisation`,
    lastUse: `Dernière utilisation`,
    noBoard: `Vous n'avez pas de board enregistrée, donc pas de stats disponibles.`,
    noSail: `Vous n'avez pas de wing ou sail enregistrée, donc pas de stats disponibles.`,
  },
  eng: {
    stats: `Gear usage stats`,
    boards: `Boards`,
    sails: `Sails/Wings`,
    active: `Active`,
    board: `Board`,
    sail: `Sail/Wing`,
    usedNb: `No. sessions`,
    totalTime: `Total use duration`,
    firstUse: `First use`,
    lastUse: `Last use`,
    noBoard: `You have no saved board, so no stats available.`,
    noSail: `You have no saved wing or sail, so no stats available.`,
  },
}
